// extracted by mini-css-extract-plugin
module.exports = {"vGray3":"#dfe1fa","desktop-up":"(min-width: calc(1280 * 1px))","header":"TableListHeader_header__3dAsQ"};